import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ModeloEventoGeneral, EventosDto } from '../dto';
import { DEFAULT_EVENTS_STORAGE } from '../dto-defaults';
import { AppStorageService } from './storage.service';
import { StorageKey } from '@ciptech/classes/storage.model';
import { CartEventCode, EventModule } from '@ciptech/classes/event.model';

@Injectable()
export class EventService {

	events$: Observable<EventosDto>;
	cartEvents$: Observable<ModeloEventoGeneral | null>;

	constructor(
		private appStorage: AppStorageService
	) {
		const initialEvents = this.eventsStorage;
		if (!this.appStorage.get<EventosDto>(StorageKey.Events)) {
			this.appStorage.set(StorageKey.Events, initialEvents);
		}

		this.events$ = this.appStorage
			.select<EventosDto>(StorageKey.Events)
			.pipe(
				map(value => value || DEFAULT_EVENTS_STORAGE),
				map(value => this.validateEventsStorage(value))
			);
		this.cartEvents$ = this.events$
			.pipe(
				map(events => events.Carrito)
			);
	}

	get eventsStorage(): EventosDto {
		const storage = this.appStorage.get<EventosDto>(StorageKey.Events);
		return this.validateEventsStorage(storage);
	}

	private validateEventsStorage(data: EventosDto | null): EventosDto {
		if (!data) {
			return { ...DEFAULT_EVENTS_STORAGE };
		}
		return {
			...DEFAULT_EVENTS_STORAGE,
			...data
		};
	}

	getEvent<T = unknown>(module: EventModule): ModeloEventoGeneral<T> | null {
		return this.eventsStorage[module] as ModeloEventoGeneral<T> | null;
	}

	setEvent<T>(module: EventModule, event: ModeloEventoGeneral<T>): void {
		const storage = this.eventsStorage;
		storage[module] = event;
		this.appStorage.set(StorageKey.Events, storage);
	}

	clearEvent(module: EventModule): void {
		const storage = this.eventsStorage;
		storage[module] = null;
		this.appStorage.set(StorageKey.Events, storage);
	}

	setCartEvent<T>(codigoEvento: CartEventCode, data?: T): void {
		this.setEvent(EventModule.Cart, this.createEvent(codigoEvento, data));
	}

	getCartEvent<T = unknown>(): ModeloEventoGeneral<T> | null {
		return this.getEvent<T>(EventModule.Cart);
	}

	clearCartEvent(): void {
		this.clearEvent(EventModule.Cart);
	}

	private createEvent<T>(codigoEvento: string, data?: T): ModeloEventoGeneral<T> {
		return {
			Id: this.generateId(),
			CodigoEvento: codigoEvento,
			Fecha: new Date().toISOString(),
			Data: data
		};
	}

	private generateId(): string {
		// Reemplazar por el generador de IDs del proyecto.
		return `${Date.now()}_${Math.random().toString(36).substring(2, 10)}`;
	}
}
